import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'pc-project-card',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './project-card.component.html',
  styleUrl: './project-card.component.scss'
})
export class ProjectCardComponent {
  @Input() imageUrl: string = '';
  @Input() title: string = '';
  @Input() divisions: Array<string> = [];
  @Input() projectUrl: string = '';
  @Input() projectDate: Date = new Date;
}
